import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { GamPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/ads/GamPlugin';
import { HlsPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/playback/HlsPlugin';
import { ShakaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/playback/ShakaPlugin';
import { TrackingServicePlugin } from 'tag/ts/tag/player/adapters/avia/plugins/tracking/TrackingServicePlugin';
import { PlayerUIPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/ui/PlayerUIPlugin';
export class AviaPluginsManager extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPluginsManager'
        });
    }
    get debugging() {
        if (!this.runtimeVO?.debug?.on) {
            return {};
        }
        return {
            forceAllPluginsToLoad: false
        };
    }
    get #allPluginsRoster() {
        return [
            new TrackingServicePlugin({ tag: this?.tag }),
            new GamPlugin({ tag: this?.tag }),
            new PlayerUIPlugin({ tag: this?.tag }),
            new ShakaPlugin({ tag: this?.tag }),
            new HlsPlugin({ tag: this?.tag })
        ];
    }
    #generatePluginConfigs = (pluginRoster) => {
        const pluginConfigs = [];
        if (this.debugging?.forceAllPluginsToLoad) {
            this?.logger?.log('Forcing all plugins to load');
        }
        pluginRoster.forEach((plugin) => {
            if (!plugin?.shouldBeUsed() && !this.debugging?.forceAllPluginsToLoad) {
                this?.logger?.log('Plugin will not be used:', plugin?.name, plugin);
                return;
            }
            this?.logger?.log('Plugin will be imported:', plugin?.name, plugin);
            try {
                const generatedConfig = plugin.generateConfig();
                if (!this.utils.Type.isNullOrUndefined(generatedConfig)) {
                    pluginConfigs.push(generatedConfig);
                }
            }
            catch (e) {
                this?.logger?.log('plugin ', plugin.name, ' initialization failed', e);
            }
        });
        return pluginConfigs;
    };
    getAllPlugins = () => {
        const pluginsRoster = this.#allPluginsRoster;
        const initializedPlugins = this.#generatePluginConfigs(pluginsRoster);
        this?.logger?.log('plugins initialized:', initializedPlugins);
        return initializedPlugins;
    };
}
